import { environment } from '../../../../environments/environment';

const configTitle = 'SignGaze - Hassle Free Advertisement';
const configDescription = '';
const configImage = 'https://signgaze.com/assets/images/logo.png';
const configSlug = '/';

export class OpenGraphConfig {
  url: any;
  constructor(
    public title: string = configTitle,
    public description: string = configDescription,
    public image: string = configImage,
    public slug: string = configSlug
  ) {
    this.url = `${environment.originURL}${this.slug}`;
  }
}
